import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceSeparatorRenderComponent } from './piece-separator-render.component';


export const pieceSeparatorRenderModuleEntryComponents = [
  PieceSeparatorRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: pieceSeparatorRenderModuleEntryComponents
})
export class PieceSeparatorRenderModule {}

export default pieceSeparatorRenderModuleEntryComponents;
